import React from "react";
import styled from "styled-components";
import quotes from "./quotes";
import moment from "moment";

const dayOfYear = moment().dayOfYear();
const quoteOfTheDay = quotes.quotes[dayOfYear];

export const Quote = () => {
  return (
    <Wrapper>
      <QuoteWrapper>
        <QuoteText>{quoteOfTheDay.quote}</QuoteText>
        <QuoteAuthor>{quoteOfTheDay.author}</QuoteAuthor>
      </QuoteWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
`;

const QuoteWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  max-width: 800px;
  justify-content: flex-end;
  letter-spacing: 1.5px;
  font-weight: lighter;
`;

const QuoteText = styled.div`
  font-size: 32px;
  text-align: center;
  line-height: 1.6;
  flex-basis: 100%;
`;

const QuoteAuthor = styled.div`
  font-size: 18px;
  max-width: 800px;
  text-align: right;
  &::before {
    content: '–';
    margin-right: 6px;
  }
`;
